import { StyleSheet } from 'react-native';


export const workOrderFormStyles = StyleSheet.create({
	container: {
		flex: 1,
		padding: 24,
		backgroundColor: '#f8f9fa',
	},
	title: {
		marginBottom: 32,
		textAlign: 'center',
		fontSize: 28,
		fontWeight: '700',
		color: '#212121',
	},
	input: {
		marginBottom: 20,
	},
	label: {
		marginVertical: 8,
		fontSize: 14,
		color: '#424242',
		fontWeight: '600',
		textTransform: 'uppercase',
		letterSpacing: 0.5,
	},
	pickerContainer: {
		borderWidth: 1,
		borderColor: '#e0e0e0',
		borderRadius: 8,
		marginBottom: 20,
		minHeight: 56,
		backgroundColor: '#ffffff',
		boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
	},
	picker: {
		height: 56,
		paddingHorizontal: 16,
	},
	dateContainer: {
		flexDirection: 'row',
		alignItems: 'center',
		marginBottom: 20,
		gap: 16,
	},
	dateButton: {
		flex: 1,
		minHeight: 56,
	},
	typeaheadContainer: {
		marginBottom: 20,
		minHeight: 56,
	},
	buttonContainer: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		marginTop: 32,
		marginBottom: 32,
		gap: 16,
	},
	button: {
		flex: 1,
		marginHorizontal: 8,
		minHeight: 56,
		borderRadius: 8,
	},
	segmentedButtons: {
		marginBottom: 20,
		backgroundColor: '#ffffff',
		borderRadius: 8,
		borderWidth: 1,
		borderColor: '#e0e0e0',
		boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
	},
	rowContainer: {
		flexDirection: 'row',
		alignItems: 'center',
		marginBottom: 20,
		gap: 16,
	},
	associationContainer: {
		flex: 1,
	},
	viewButton: {
		marginLeft: 16,
	},
	section: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: 20,
		marginBottom: 20,
	},
	row: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: 16,
	},
	// Form sections with better organization
	formSection: {
		marginBottom: 32,
		padding: 20,
		backgroundColor: '#ffffff',
		borderRadius: 12,
		borderWidth: 1,
		borderColor: '#e0e0e0',
		boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
	},
	formSectionTitle: {
		fontSize: 18,
		fontWeight: '600',
		color: '#212121',
		marginBottom: 16,
		paddingBottom: 8,
		borderBottomWidth: 2,
		borderBottomColor: '#2196f3',
	},
	formRow: {
		flexDirection: 'row',
		gap: 16,
		marginBottom: 20,
	},
	formField: {
		flex: 1,
	},
	multilineInput: {
		minHeight: 120,
		textAlignVertical: 'top',
	},
	// Visual hierarchy improvements
	requiredField: {
		borderLeftWidth: 4,
		borderLeftColor: '#2196f3',
		paddingLeft: 12,
	},
	optionalField: {
		opacity: 0.8,
	},
	fieldGroup: {
		marginBottom: 24,
		padding: 16,
		backgroundColor: '#f5f5f5',
		borderRadius: 8,
		borderWidth: 1,
		borderColor: '#e0e0e0',
	},
	fieldGroupTitle: {
		fontSize: 16,
		fontWeight: '600',
		color: '#424242',
		marginBottom: 12,
		paddingBottom: 8,
		borderBottomWidth: 1,
		borderBottomColor: '#e0e0e0',
	},
});
